import React, { useState } from 'react';

// project-imports
import SEO from '../../common/SEO';
import Layout from '../../common/Layout';
import StencilBox from '../../components/stencils/StencilBox';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';

// third-party
import { Accordion } from 'react-bootstrap';

// Constant variable 
// Faqs data
const accordionItems = [
    {
        id: 1,
        title: ' What is Salesforce CRM?',
        body: '<p>Salesforce CRM, or Customer Relationship Management, is a cloud-based platform that helps businesses manage their interactions and relationships with customers and potential customers.</p>'
    },
    {
        id: 2,
        title: 'What does a Salesforce Administrator do?',
        body: '<p>A Salesforce Administrator is responsible for configuring and customizing the Salesforce platform to meet the specific needs of their organization.</p>'
    },
    {
        id: 3,
        title: 'Can I learn Salesforce development without prior coding experience?',
        body: '<p>Yes, our courses are designed to cater to individuals with various levels of coding experience, including beginners.</p>'
    },
    {
        id: 4,
        title: 'What is the importance of ReactJS in web development?',
        body: '<p>ReactJS is a JavaScript library widely used for building user interfaces, providing a fast and efficient way to create interactive and dynamic web applications.</p>'
    },
    {
        id: 5,
        title: 'How can I get started with Salesforce development?',
        body: '<p>You can begin by learning the basics of Salesforce, understanding Apex <strong>Salesforce programming language</strong>  and exploring the development tools provided by Salesforce.</p>'
    },
    {
        id: 6,
        title: 'What skills are essential for a Salesforce Developer?',
        body: '<p>Key skills include proficiency in Apex, understanding of Salesforce data model, knowledge of Lightning components, and familiarity with web technologies.</p>'
    },
    {
        id: 7,
        title: ' Is JavaScript necessary for Salesforce development?',
        body: '<p>While not mandatory, having a good understanding of JavaScript can enhance your capabilities as a Salesforce developer, especially when working with Lightning components.</p>'
    },
    {
        id: 8,
        title: ' What are the advantages of using Salesforce over traditional CRM systems?',
        body: '<p>Salesforce offers cloud-based accessibility, scalability, customization options, and a user-friendly interface, setting it apart from traditional CRM systems.</p>'
    },
    {
        id: 9,
        title: 'Can I access Salesforce from mobile devices?',
        body: '<p>Yes, Salesforce provides mobile applications, allowing users to access CRM data and functionalities from smartphones and tablets.</p>'
    },
    {
        id: 10,
        title: ' How can I stay updated on the latest Salesforce features and updates?',
        body: '<p>Regularly check Salesforce release notes, join online communities, and participate in forums and webinars to stay informed about the latest developments.</p>'
    },
    {
        id: 11,
        title: 'What is the role of a React JS developer in web development projects?',
        body: '<p>A React JS developer focuses on building user interfaces and ensuring a seamless user experience by creating reusable components and efficiently managing application state.</p>'
    },
    {
        id: 12,
        title: 'Can I integrate ReactJS with Salesforce?',
        body: '<p> Yes, you can integrate ReactJS with Salesforce using various methods, such as Lightning Web Components or by building custom Visualforce pages.</p>'
    },
    {
        id: 13,
        title: 'Is it necessary to learn both Salesforce administration and development?',
        body: '<p> While not mandatory, having a combined understanding of administration and development can make you a more versatile and valuable Salesforce professional.</p>'
    },
    {
        id: 14,
        title: 'Are there certifications for Salesforce professionals?',
        body: '<p> Yes, Salesforce offers various certifications for administrators, developers, and architects, which can enhance your credibility in the industry.</p>'
    },
    {
        id: 15,
        title: 'How can I troubleshoot common issues in Salesforce?',
        body: '<p> Understanding Salesforce error messages, checking logs, and utilizing the developer console are essential tools for troubleshooting common issues.</p>'
    },
    {
        id: 16,
        title: ' Can I use JavaScript libraries other than React with Salesforce?',
        body: '<p> Yes, you can use other JavaScript libraries, but React is well-supported within the Salesforce ecosystem and is a popular choice for building Lightning components.</p>'
    },
    {
        id: 17,
        title: 'What is the future outlook for careers in Salesforce?',
        body: '<p> Careers in Salesforce are promising, with increasing demand for skilled professionals as more businesses adopt Salesforce for their CRM and development needs.</p>'
    },
    {
        id: 18,
        title: 'How long does it typically take to learn ReactJS?',
        body: '<p> The learning duration varies, but with consistent effort, you can gain a good understanding of ReactJS in a few months, especially with hands-on practice.</p>'
    },
    {
        id: 19,
        title: ' Are there real-world projects included in your courses?',
        body: '<p> Yes, our courses include practical projects and hands-on exercises to ensure that you can apply your knowledge to real-world scenarios.</p>'
    },
    {
        id: 20,
        title: 'Can I connect with other learners and professionals through your platform?',
        body: '<p>Yes, we encourage networking and collaboration among our learners through forums, discussion groups, and community events on our platform.</p>'
    },

];

// Constant function 
const CustomToggle = () => {
    return <button
        type="button"
        className="edu-accordion-button stencil">
        <StencilBox
            width="100%"
            height="52.16px"
            backgroundColor="#EEF1F6"
        />
    </button>
}
const Faq = (props) => {
    
    // Sate variable initialization
    const [activeId, setActiveId] = useState('0');
    return (
        <>
            <SEO title="All category" isCrawlable={false} /> {/* Set SEO title */}
            <Layout>
                <BreadcrumbOne
                    title="All FAQs" // Breadcrumb title 
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="All FAQs"

                />
                <div className="edu-course-area ptb--60 bg-color-white">
                    <div className="container mb--130">
                        <div className="row g-5 mt--10 text-center">
                            <div className="col-xl-8 offset-xl-2 mt-0">
                                <Accordion bsPrefix="landing-demo-faq edu-accordion-02 variation-2 landing-page-accordion bg-color-transparent" defaultActiveKey="0" flush>
                                    {accordionItems && accordionItems.length &&
                                        accordionItems.map((accordion, i) => (
                                            <Accordion.Item eventKey={i.toString()} key={i} bsPrefix={`edu-accordion-item ${activeId === i.toString() ? 'bg-active' : ''}`}>
                                                <div className="edu-accordion-header">
                                                    <CustomToggle eventKey={i.toString()}>
                                                        <StencilBox
                                                            width="100%"
                                                            height="60px"
                                                            backgroundColor="#EEF1F6"
                                                        />
                                                    </CustomToggle>
                                                </div>
                                                <Accordion.Body bsPrefix="edu-accordion-body"><div >
                                                    <StencilBox
                                                        width="100%"
                                                        height="52.16px"
                                                        backgroundColor="#EEF1F6"
                                                    />
                                                </div></Accordion.Body>
                                            </Accordion.Item>
                                        ))
                                    }
                                </Accordion>
                            </div>
                        </div>
                    </div>
                </div>

            </Layout>
        </>
    )
}

export default Faq;